export const cbtExercises = {
  thought_reframing: [
    {
      trigger: 'high_stress',
      original_thought: "I can't handle this.",
      reframed: "This is hard, but I've handled hard things before. I can take it one step at a time.",
      action: "Write down one thing you've overcome recently.",
    },
    {
      trigger: 'high_stress',
      original_thought: "Everything is falling apart.",
      reframed: "Some things are challenging right now, but not everything. Let me focus on what I can control.",
      action: "List 3 things that are going okay today.",
    },
    {
      trigger: 'overwhelmed',
      original_thought: "I have to do it all right now.",
      reframed: "I can't do everything at once, and that's okay. What's the one thing that matters most?",
      action: "Pick one task. Do just that for 10 minutes.",
    },
    {
      trigger: 'overwhelmed',
      original_thought: "I'm failing at everything.",
      reframed: "I'm doing my best with what I have. Progress, not perfection.",
      action: "Name one small win from today.",
    },
    {
      trigger: 'anxious',
      original_thought: "Something bad is going to happen.",
      reframed: "I'm worried, but worry isn't a prediction. I can handle what comes.",
      action: "Ground yourself: name 5 things you see, 4 you can touch, 3 you hear.",
    },
    {
      trigger: 'anxious',
      original_thought: "I'm not good enough.",
      reframed: "I'm learning and growing. Good enough is already here.",
      action: "Text someone you trust. Connection helps.",
    },
    {
      trigger: 'sad',
      original_thought: "Nothing will get better.",
      reframed: "This feeling is real, and it's also temporary. Things shift.",
      action: "Do one small thing you enjoy—even 2 minutes counts.",
    },
    {
      trigger: 'sad',
      original_thought: "I'm alone in this.",
      reframed: "I'm struggling right now, and that's human. Others care.",
      action: "Reach out to one person. A text, a call, anything.",
    },
  ],
};

export function shouldTriggerCBT(mood, stress) {
  // Trigger if stress > 6 OR mood is stressed/overwhelmed
  const highStress = stress > 6;
  const triggerMoods = ['stressed', 'overwhelmed'];
  
  return highStress || triggerMoods.includes(mood);
}

export function getCBTExercise(mood, stress) {
  if (!shouldTriggerCBT(mood, stress)) {
    return null;
  }

  // Determine trigger type
  let triggerType = 'high_stress';
  if (mood === 'overwhelmed') {
    triggerType = 'overwhelmed';
  } else if (mood === 'stressed' && stress > 8) {
    triggerType = 'anxious';
  }

  // Get matching exercises
  const matchingExercises = cbtExercises.thought_reframing.filter(
    (ex) => ex.trigger === triggerType
  );

  // Return random exercise
  if (matchingExercises.length === 0) {
    return cbtExercises.thought_reframing[0];
  }

  return matchingExercises[Math.floor(Math.random() * matchingExercises.length)];
}
